export const HENRIQUE_E_JULIANO = "HENRIQUE_E_JULIANO";
